import { Route } from 'react-router-dom'
import { AlbumShellLayout } from '@/features/album/layouts/AlbumShellLayout'
import { NotificationsScreen } from './screens/Notifications'

/**
 * Notifications route — mounted inside album/routes.tsx's `AlbumDesignRoot`
 * (auth + DS provider), reusing the same app shell as /albums, /galleries,
 * and /settings so the product's chrome stays consistent.
 *
 * Reuses the legacy `/notification` path (singular) so every existing link —
 * the sidebar nav item, the header bell — keeps working unchanged.
 *
 * /notification
 */
export const notificationsRouteElements = (
  <Route path='notification' element={<AlbumShellLayout />}>
    <Route index element={<NotificationsScreen />} />
  </Route>
)
